import { Graphics } from "pixi.js"
import { BOTTOM, GuiManager } from "../gui_manager"
import { TextRenderer } from "../text/text_renderer"
import { DyanmicTextContainer } from "./dynamic_text_container"
import { FullScreenModal } from "./fullscreen_modal"
import { HELP_ENTRIES } from "./help_entries"

export class Help extends FullScreenModal {
    constructor(guiManager: GuiManager) {
        super(guiManager)
    }

    static attachHelp = (textBlock: DyanmicTextContainer) => {
        HELP_ENTRIES.forEach((entry, i) => {
            const block = new DyanmicTextContainer()
            block
                .append2(new TextRenderer().color(0xffa500).bold().render(entry.title) as Graphics)
                .append2(new TextRenderer().render(entry.body) as Graphics)

            textBlock.append2(block, i > 0 ? { topMargin: 8 } : undefined)
        })
    }

    createContent = () => {
        const textBlock = new DyanmicTextContainer()

        textBlock.append2("").append2("")

        Help.attachHelp(textBlock)

        const media = this.guiManager.socialMedia()
        textBlock.append2(media, {
            exactLocation: {
                x: 0,
                y: BOTTOM - media.height - 10,
            },
        })

        return textBlock
    }
}
